import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Contact from "./contact/Contact";
import Project from "./product/Project";
import Footer from "../layout/footer/Footer";
import WhyUs from "./whyUs/WhyUs";
import OurServices from "./Services/OurServices";
import Dashboard from "./Dashboard/Dashboard";
import WhatWeDo from "./whatWeDo/WhatWeDo";
import BlurImage from "../assets/BlurImage.png";
import Insytix from "../assets/TechInstitutelogo.png";

const Home = () => {
  const [show, setShow] = useState(false); // Initially, do not show the modal
  const navigate = useNavigate();

  // Check sessionStorage immediately on load to see if modal has been closed
  useEffect(() => {
    const modalClosed = sessionStorage.getItem("modalClosed");
    if (modalClosed) {
      setShow(false); // If it's closed, do not show the modal
    } else {
      setShow(true); // Otherwise, show the modal
    }
  }, []);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden"; // Prevent scrolling when modal is visible

      // Set timeout to automatically close modal after 10 seconds (adjustable)
      const timeout = setTimeout(() => {
        setShow(false); // Close modal after timeout
        sessionStorage.setItem("modalClosed", "true"); // Store in sessionStorage to prevent showing again
      }, 20000); 

      // Cleanup timeout if modal is closed or component unmounts
      return () => {
        clearTimeout(timeout);
        document.body.style.overflow = "auto"; // Restore scrolling
      };
    } else {
      document.body.style.overflow = "auto"; // Allow scrolling once modal is closed
    }
  }, [show]);

  const closeModal = () => {
    setShow(false);
    sessionStorage.setItem("modalClosed", "true"); // Set sessionStorage to avoid showing modal again in this session
  };

  const handleExploreClick = () => {
    closeModal();
    navigate("/techInstitute");
  };

  return (
    <>
      {show && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-75 md:flex">
          {/* Spark Background */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute top-0 left-0 w-32 h-32 md:w-64 md:h-64 rounded-full bg-gradient-to-r from-white to-transparent opacity-50 animate-ping"></div>
            <div className="absolute bottom-0 right-0 w-32 h-32 md:w-64 md:h-64 rounded-full bg-gradient-to-r from-yellow-500 to-transparent opacity-50 animate-ping"></div>
            <div className="absolute top-20 right-20 w-24 h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-r from-blue-500 to-transparent opacity-50 animate-pulse"></div>
          </div>

          <div
            className="sm:relative sm:h-80 w-[95%]   md:w-1/2 bg-no-repeat rounded-xl py-5 bg-cover z-50 "

            style={{ backgroundImage: `url(${BlurImage})` }}
          >
            <div className="flex justify-center items-center scroll -mt-14">
            <div className=" w-24 h-28 md:w-48 pt-5">
              <img src={Insytix} alt="Insytix Logo" className=" " />
            </div>
            </div>
<br></br>
            <div className="md:text-center ">
              {/* <p className="text-2xl md:text-3xl font-semibold font-poppins text-center leading-relaxed pb-5">
              Introducing INSYTIX Tech Institute
              </p> */}
              <div className="sm:text-center  px-3 md:text-center pt-10 ">
                <div className=" sm:flex flex-col   px-10 text-center justify-center items-center whitespace-nowrap md:px-36 md:flex-row ">
                  <p className="sm:text-sm font-poppins leading-relaxed font-light text-gray-800 mr-1">
                  We’re excited to announce the launch of our new venture – INSYTIX Tech Institute.
                  </p>
                </div>
                <p className="sm:text-sm py-1 leading-relaxed font-poppins text-center font-light text-gray-800 md:text-sm">
                Our mission is to make cutting-edge technology training accessible to everyone,<br/>
                at highly affordable fees, while ensuring top-quality learning in the most in-demand skills.
              </p>
                {/* <p className="sm:text-sm py-1 leading-relaxed font-poppins text-center font-light text-gray-800 md:text-sm">
                Explore our programs and take the next step in your career journey.
                </p> */}
              </div>

              <br />
              <div className="text-center">
                  <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition duration-300"
                  onClick={handleExploreClick}
                >
                  Explore Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={show ? "filter blur-sm pointer-events-none relative" : ""}>
        <Dashboard />
        <WhatWeDo />
        <OurServices />
        <Project />
        <WhyUs />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default Home;
